export default "__VITE_ASSET__P2LyJ_$p__"